export default __webpack_public_path__ + "static/media/Tron icon.67343730.svg";